export const publisherConstants = {
    UPDATE_PUBLISHER_REQUEST: 'UPDATE_PUBLISHER_REQUEST',
    UPDATE_PUBLISHER_SUCCESS: 'UPDATE_PUBLISHER_SUCCESS',
    UPDATE_PUBLISHER_FAILURE: 'UPDATE_PUBLISHER_FAILURE',
}